import { render, staticRenderFns } from "./PCGovernanceItemBigger.vue?vue&type=template&id=301d4c5e&scoped=true"
import script from "./PCGovernanceItemBigger.vue?vue&type=script&setup=true&lang=js"
export * from "./PCGovernanceItemBigger.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PCGovernanceItemBigger.vue?vue&type=style&index=0&id=301d4c5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301d4c5e",
  null
  
)

export default component.exports